import { TFunction } from 'i18next';
import * as Yup from 'yup';
import commonUtils from '@/utils/common';
import regex from './regex';

export enum ValidationErrors {
  PASSWORD_REQUIREMENTS = 'password_requirements',
  IS_REQUIRED = 'is_required',
  PASSWORDS_DONT_MATCH = 'passwords_dont_match',
  COGNITO_VERIFICATION_CODE_LENGTH = 'cognito_verification_code_length',
  EMAIL_FORMAT = 'email_format',
}

export const createSchema = (data: any) => {
  return Yup.object().shape(data);
};

export const minValidation = (t: TFunction, min: number): Yup.AnyObject => {
  return Yup.string().min(min, (args: { min: number; path: string }) => {
    return t('validation.mustBeAtLeastCharacters', { length: args.min });
  });
};

export const passwordValidation = (): Yup.AnyObject => {
  return Yup.string().matches(regex.passwordValidator(), ValidationErrors.PASSWORD_REQUIREMENTS);
};

export const confirmPasswordValidation = (): Yup.AnyObject => {
  return Yup.string()
    .required(ValidationErrors.IS_REQUIRED)
    .oneOf([Yup.ref('password')], ValidationErrors.PASSWORDS_DONT_MATCH);
};

export const cognitoVerificationCodeValidation = (): Yup.AnyObject => {
  return Yup.string()
    .min(6, ValidationErrors.COGNITO_VERIFICATION_CODE_LENGTH)
    .required(ValidationErrors.IS_REQUIRED);
};

export const emailValidation = (): Yup.AnyObject => {
  return Yup.string().email(ValidationErrors.EMAIL_FORMAT).required(ValidationErrors.IS_REQUIRED);
};

/**
 * Sanitizes email input by removing whitespace characters (spaces, newlines, tabs, etc.)
 */
export const sanitizeEmail = (email: string): string => {
  return commonUtils.sanitizeEmailInput(email);
};
